import type { AgentRunSummary } from "@common/schemas/domains/agentRuns/agent-run.schema";
import type {
    TaskActivityEvent,
    TaskActivityPayload,
} from "@common/schemas/domains/agentRuns/task-activity.schema";
import type { AgentRunStep } from "@common/types/agentRun";

/** The five run states the demo shows, in the order a dataset hands them out. */
export const DEMO_RUN_KINDS = [
    "working",
    "waitingOnClient",
    "paused",
    "needsReview",
    "finished",
] as const;

export type DemoRunKind = (typeof DEMO_RUN_KINDS)[number];

/** An event the ticker appends later, with the status line it leaves behind. */
export interface DemoScriptedStep {
    eventId: string;
    payload: TaskActivityPayload;
    /** A teammate's user id for a human event; null for the agent. */
    actorId: number | null;
    progress: { step: AgentRunStep; detail: string };
    /** Clears the pause, for a teammate continuing a paused run. */
    shouldResume?: true;
}

/** A fake run as the live store keeps it: events newest first. */
export interface DemoRunRecord {
    run: AgentRunSummary;
    taskTitle: string;
    events: readonly TaskActivityEvent[];
    queue: readonly DemoScriptedStep[];
    /** Epoch ms of the newest event, which paces the ticker. */
    lastEventAt: number;
}

/** A fake item's viewers (replaced, never mutated) and who may join it. */
export interface DemoViewerRecord {
    viewerIds: number[];
    candidateIds: readonly number[];
}

/** What a dataset hands the live store: added once per id, never overwritten. */
export interface DemoDataset {
    runs: readonly DemoRunRecord[];
    viewersByTargetId: ReadonlyMap<string, DemoViewerRecord>;
}
